export const CSW_INTERACTED_KEY = 'cswInteracted'

export const SEARCH_INTERACTED_KEY = 'searchInteracted'
